import BeneficialOwnersFormContent from './BeneficialOwnersFormContent'

export default BeneficialOwnersFormContent
